import { IEventV2 } from '@travelnest/typewriter';
import React from 'react';
import { connect } from 'react-redux';
import { IPostPayment } from '../../../../data/entities/post-payment';
import { queuePostPayment } from '../../../../entities/post-payment/actions';
import { IThunkDispatch } from '../../../../store/middleware';
import { NewExceptionalPaymentComponent } from './NewExceptionalPaymentComponent';

interface INewExceptionalPaymentProps {
	expanded: boolean;
	event: IEventV2;
	submitPostPayments: (payments: IPostPayment[], eventId: string) => void;
}

const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
	submitPostPayments: (payments: IPostPayment[], eventId: string) => dispatch(queuePostPayment('add', payments, eventId))
});

const NewExceptionalPaymentContainer: React.FC<INewExceptionalPaymentProps> = (props) => {
	return <NewExceptionalPaymentComponent
		expanded={props.expanded}
		event={props.event}
		submitPostPayments={props.submitPostPayments}
	/>;
};

export const NewExceptionalPayment = connect(null, mapDispatchToProps)(NewExceptionalPaymentContainer);
